module.exports = __webpack_public_path__ + "static/ayisha-f5ea2381749ba4619f737bccd99e290b.jpeg";